import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/case-vouchers.js';
import { insightsScopeKey } from '../insights/filter-params.js';
import q from '../query.js';
export const caseVouchersEntity = 'case-vouchers';
const caseVouchersKey = (query, page, pageSize) => `case-vouchers-${page}-${pageSize}-${JSON.stringify(query)}`;
export const useCaseVouchers = (query, page, pageSize) => q.query(caseVouchersKey(query, page, pageSize), () => {
    return api.getMultiple(query, {
        page,
        pageSize,
    });
}, keys.read.collection(caseVouchersEntity));
const caseVoucherRecognitionsKey = (transactionAccountId) => `case-voucher-recognitions-${transactionAccountId}`;
// Deliberately NOT registered under the case-vouchers collection key:
// recognition is a full recognizer scan server-side, and coupling it to every
// voucher write would re-run that scan on each single-voucher action.
// Invalidate this key explicitly after mapping or importing deposits.
export const caseVoucherRecognitionsRefreshKey = 'case-voucher-recognitions';
export const useCaseVoucherRecognitions = (transactionAccountId) => q.query(caseVoucherRecognitionsKey(transactionAccountId), () => api
    .getRecognitions(transactionAccountId)
    .then((response) => response.recognitions), [caseVoucherRecognitionsRefreshKey]);
export const caseVouchersKeyByCase = (caseId, options) => `case-vouchers-${caseId}-deleted:${options.getDeleted ? true : false}`;
export const useCaseVouchersByCase = (caseId, options = {}) => q.query(caseVouchersKeyByCase(caseId, options), () => api.getByCaseId(caseId, options), keys.read.collection(caseVouchersEntity), {
    enabled: caseId != null,
});
const depositInsightsKey = `deposit-insights`;
export const useDepositInsights = () => q.query(depositInsightsKey, api.getDepositInsights, keys.read.collection(caseVouchersEntity));
const expirationInsightsByMonthKey = `expiration-insights-by-month`;
export const useExpirationInsightsByMonth = ({ caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${expirationInsightsByMonthKey}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getExpirationInsightsByMonth({
    caseGroupIds,
    creditorIds,
}), []);
const expirationInsightsBreakdownKey = (month) => `expiration-insights-breakdown-${month}`;
export const useExpirationInsightsBreakdownForMonth = (month, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${expirationInsightsBreakdownKey(month ?? '')}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getExpirationInsightsBreakdownForMonth(month, {
    caseGroupIds,
    creditorIds,
}), [], { enabled: month != null });
const expirationSuspensionInsightsByMonthKey = (from, to) => `expiration-suspension-insights-by-month-and-type-${from}-${to}`;
export const useExpirationSuspensionInsightsByMonthAndType = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${expirationSuspensionInsightsByMonthKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getExpirationSuspensionInsightsByMonthAndType(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const portfolioCompositionByMonthKey = (from, to) => `portfolio-composition-by-month-${from}-${to}`;
export const usePortfolioCompositionByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${portfolioCompositionByMonthKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getPortfolioCompositionByMonth(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const incomingPaymentsInsightsKey = (from, to) => `incoming-payments-insights-${from}-${to}`;
export const useIncomingPaymentsInsights = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${incomingPaymentsInsightsKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getIncomingPaymentsInsights(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
//# sourceMappingURL=index.js.map